import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AllocationComponent } from './allocation.component';
import { GlobalModulesModule } from '../../global-modules/global-modules.module';
import { AllocFilterComponent } from './alloc-filter/alloc-filter.component';
import { CampaignWizardModule } from '../campaign-wizard/campaign-wizard.module';
import { GroupSelectorComponent } from './group-selector/group-selector.component';
import { WebUserSelectorComponent } from './web-user-selector/web-user-selector.component';
import { CampaignDistributionSelectorComponent } from './campaign-distribution-selector/campaign-distribution-selector.component';
import { WebUserMultiSelectorComponent } from './web-user-multi-selector/web-user-multi-selector.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    CampaignWizardModule
  ],
  declarations: [AllocationComponent, AllocFilterComponent, GroupSelectorComponent, WebUserSelectorComponent, CampaignDistributionSelectorComponent, WebUserMultiSelectorComponent],
  entryComponents: [AllocFilterComponent, GroupSelectorComponent, WebUserSelectorComponent],
  exports: [AllocationComponent]
})
export class AllocationModule { }
